/* eslint-disable padded-blocks */
/* eslint-disable space-before-function-paren */
import { AddIcon, MinusIcon } from '@chakra-ui/icons';
import {
  Accordion,
  AccordionButton,
  AccordionItem,
  AccordionPanel,
  Box
} from '@chakra-ui/react';

const SimpleFaq = ({ faqSection }) => {
  return (
    <>
      {faqSection.faqs?.map(data => {
        return (
          <Accordion
            className="simplefaq"
            width={{ lg: '690px', md: '90%', sm: '90%' }}
            m="0 auto"
            fontFamily="FedraSansStd-book, sans-serif"
            allowToggle
          >
            <AccordionItem
              borderTop="0"
              borderBottom={{
                base: '1px solid #DDDDDD',
                md: '1px solid #DFD6C4',
              }}
            >
              {({ isExpanded }) => (
                <>
                  <h2>
                    <AccordionButton
                      border="none"
                      borderColor="#DFD6C4"
                      _hover={{
                        backgroundColor: '#ffffff',
                      }}
                      p={{ base: '12px 0', md: '16px' }}
                    >
                      <Box
                        flex="1"
                        textAlign="left"
                        fontSize={{ lg: '18px', md: '18px', sm: '16px' }}
                        lineHeight="26px"
                        fontWeight="bold"
                        p="12px 0"
                      >
                        {data.question}
                      </Box>
                      {isExpanded ? (
                        <MinusIcon fontSize="15px" color="#CF4520" />
                      ) : (
                        <AddIcon fontSize="15px" color="#CF4520" />
                      )}
                    </AccordionButton>
                  </h2>
                  <AccordionPanel
                    pb={4}
                    fontFamily="FedraSansStd-book"
                    fontSize={{
                      lg: '18px',
                      md: '18px',
                      sm: '16px',
                      base: '16px',
                    }}
                    lineHeight="26px"
                    textAlign="left"
                  >
                    <Box
                      dangerouslySetInnerHTML={{
                        __html: data.answer,
                      }}
                    />
                  </AccordionPanel>
                </>
              )}
            </AccordionItem>
          </Accordion>
        );
      })}
    </>
  );
};

export default SimpleFaq;
